module.exports = __webpack_public_path__ + "static/media/speaker-off.d86bda8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/player-controls/speaker-off.svg
// module id = 606
// module chunks = 0